import { render, staticRenderFns } from "./pix.vue?vue&type=template&id=5284e21c"
import script from "./pix.vue?vue&type=script&lang=js"
export * from "./pix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports